// extracted by mini-css-extract-plugin
export default {"subtema":"Subtema_subtema__sWgRy"};